import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vue from 'vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// only import the icons you use to reduce bundle size
import 'vue-awesome/icons/plus'
import 'vue-awesome/icons/sync'
import 'vue-awesome/icons/chevron-left'
import 'vue-awesome/icons/arrow-left'
import 'vue-awesome/icons/arrow-right'
import 'vue-awesome/icons/download'
import 'vue-awesome/icons/toggle-on'
import 'vue-awesome/icons/toggle-off'
import 'vue-awesome/icons/check'
import 'vue-awesome/icons/edit'
import 'vue-awesome/icons/trash'
import 'vue-awesome/icons/square'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/images'
import 'vue-awesome/icons/check-square'
import 'vue-awesome/icons/folder-open'
import 'vue-awesome/icons/file-download'
import 'vue-awesome/icons/sign-out-alt'
import 'vue-awesome/icons/save'
import 'vue-awesome/icons/print'

import Icon from 'vue-awesome/components/Icon'

// import Swiper JS

// globally (in your main .js file)
Vue.component('v-icon', Icon);

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

// Global registration
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead)

import axios from 'axios';
import { Model } from 'vue-api-query'

Model.$http = axios